const viewports = {
  methods: {
    resetViewportStyles(viewport) {
      /*
        @desktop: ~'only screen and (min-width : 993px)';
        @tablet: ~'only screen and (min-width:601px) and (max-width:992px)';
        @mobile: ~'only screen and (min-width:50px) and (max-width:600px)';
      */
      this.$store.dispatch('setGlobalViewport', viewport);

      const list = {
        desktop: {
          min: null,
          max: 993,
        },
        tablet: {
          min: 601,
          max: 992,
        },
        mobile: {
          min: 50,
          max: 600,
        },
      };
      const picazzo = window.drzzle.viewports;
      const maxWidth = 9999;

      const chosenMax = new RegExp(`max-width\\s?:\\s?${maxWidth}px`, 'gi');
      const tablet = new RegExp(`max-width\\s?:\\s?${list.tablet.max}px`, 'gi');
      const tabletMinMax = new RegExp(`max-width\\s?:\\s?${list.tablet.min}px`, 'gi');
      const mobile = new RegExp(`max-width\\s?:\\s?${list.mobile.max}px`, 'gi');
      const mobileMinMax = new RegExp(`max-width\\s?:\\s?${list.mobile.min}px`, 'gi');

      // first we set the picazzo js lib viewports
      if (viewport === 'mobile') {
        // lock tablet view to never take affect
        picazzo.tablet = picazzo.tablet.replace(tablet, `max-width: ${list.tablet.min}px`);
        picazzo.tablet = picazzo.tablet.replace(chosenMax, `max-width: ${list.tablet.min}px`);
        // give mobile a very wide range
        picazzo.mobile = picazzo.mobile.replace(mobile, `max-width: ${maxWidth}px`);
        picazzo.mobile = picazzo.mobile.replace(mobileMinMax, `max-width: ${maxWidth}px`);
      }

      if (viewport === 'tablet') {
        // lock mobile view to never take affect
        picazzo.mobile = picazzo.mobile.replace(mobile, `max-width: ${list.mobile.min}px`);
        picazzo.mobile = picazzo.mobile.replace(chosenMax, `max-width: ${list.mobile.min}px`);
        // give tablet a very wide range
        picazzo.tablet = picazzo.tablet.replace(tablet, `max-width: ${maxWidth}px`);
        picazzo.tablet = picazzo.tablet.replace(tabletMinMax, `max-width: ${maxWidth}px`);
      }

      if (viewport === 'desktop') {
        // reset both mobile and tablet to normal
        picazzo.mobile = picazzo.mobile.replace(chosenMax, `max-width: ${list.mobile.max}px`);
        picazzo.mobile = picazzo.mobile.replace(mobileMinMax, `max-width: ${list.mobile.max}px`);
        picazzo.tablet = picazzo.tablet.replace(chosenMax, `max-width: ${list.tablet.max}px`);
        picazzo.tablet = picazzo.tablet.replace(tabletMinMax, `max-width: ${list.tablet.max}px`);
      }

      // now we need to reset all the picazzo made media queries in the DOM
      const picazzoDefaults = document.querySelectorAll('head > link[data-source="picazzo"]')[0];
      const addedRules = document.querySelectorAll('body style[data-source="picazzo"]');
      const mobileMq = new RegExp(`\\(max-width\\s?:\\s?\\d+px\\)\\s?and\\s?\\(min-width\\s?:\\s?${50}px\\)|\\(min-width\\s?:\\s?${50}px\\)\\s?and\\s?\\(max-width\\s?:\\s?\\d+px\\)`, 'gi');
      const tabletMq = new RegExp(`\\(max-width\\s?:\\s?\\d+px\\)\\s?and\\s?\\(min-width\\s?:\\s?${601}px\\)|\\(min-width\\s?:\\s?${601}px\\)\\s?and\\s?\\(max-width\\s?:\\s?\\d+px\\)`, 'gi');
      const mqrules = [];

      [picazzoDefaults, ...addedRules].forEach((style) => {
        if (style) {
          const rules = [...style.sheet.cssRules];
          rules.forEach((rule, i) => {
            // type 4 are media queries
            if (rule.type === 4) {
              mqrules.push([i, rules[i].media.mediaText]);
            }
          });
          mqrules.forEach((mq) => {
            const rmq = rules[mq[0]];
            if (rmq && rmq.media) {
              const r = rmq.media.mediaText;
              if (viewport === 'mobile') {
                // lock tablet view to never take affect
                if (r.match(tabletMq)) {
                  rmq.media.mediaText = mq[1].replace(tabletMq, `(max-width: ${list.tablet.min}px) and (min-width: ${list.tablet.min}px)`);
                }
                // give mobile a very wide range
                if (r.match(mobileMq)) {
                  rmq.media.mediaText = mq[1].replace(mobileMq, `(max-width: ${maxWidth}px) and (min-width: ${list.mobile.min}px)`);
                }
              }
              if (viewport === 'tablet') {
                // lock mobile view to never take affect
                if (r.match(mobileMq)) {
                  rmq.media.mediaText = mq[1].replace(mobileMq, `(max-width: ${list.mobile.min}px) and (min-width: ${list.mobile.min}px)`);
                }
                // give tablet a very wide range
                if (r.match(tabletMq)) {
                  rmq.media.mediaText = mq[1].replace(tabletMq, `(max-width: ${maxWidth}px) and (min-width: ${list.tablet.min}px)`);
                }
              }
              if (viewport === 'desktop') {
                // reset both back to normal
                if (r.match(mobileMq)) {
                  rmq.media.mediaText = mq[1].replace(mobileMq, `(max-width: ${list.mobile.max}px) and (min-width: ${list.mobile.min}px)`);
                }
                if (r.match(tabletMq)) {
                  rmq.media.mediaText = mq[1].replace(tabletMq, `(max-width: ${list.tablet.max}px) and (min-width: ${list.tablet.min}px)`);
                }
              }
            }
          });
        }
      });
      // this is needed for droplet plugins that may have resize event listeners
      // we want them to have a simulated resize trigger
      $(window).trigger('resize');
    },
  },
};

export { viewports };



// WEBPACK FOOTER //
// ./src/mixins/viewport-switcher.js